export enum SOCIAL_TYPES_old {
    none,
    discord,
    facebook,
    line,
    mattermost,
    telegram,
    web,
    kiosk,
    autoTest = 101,
}

export enum SOCIAL_TYPES {
    SMNone = 0,
    SMDisord = 1,
    Fb = 2,
    SMLine = 3,
    SMMattermost = 4,
    SMTelegram = 5,
    SMWeb = 6,
    SMKiosk = 7,
    SMWechat = 8,
    SMPhone = 9,
    SMAutoTest = 100,
    SMAmazePlatformChat = 101,
}
